const user = {
    email: {
        value: "",
        display: "Email Address",
        type: "email",
        required: true,
    },
    password1: {
        value: "",
        display: "Password",
        type: "password",
        required: true,
    },
    password2: {
        value: "",
        display: "Confirm Password",
        type: "password",
        required: true,
    },
    smsConsent: {
        value: false,
        display: "SMS Consent",
        details: "Subscribe to marketing texts",
        type: "checkbox",
        required: false,
    },
    firstName: {
        value: "",
        display: "First Name",
        required: true,
    },
    lastName: {
        value: "",
        display: "Last Name",
        required: true,
    },
    company: {
        value: "",
        display: "Company Name",
        required: false,
    },
    street: {
        value: "",
        display: "Street Address",
        required: true,
    },
    apt: {
        value: "",
        display: "Apt/Ste/Rm",
        required: false,
    },
    city: {
        value: "",
        display: "City",
        required: true,
    },
    country: {
        value: null,
        display: "Country",
        type: "select",
        required: true,
    },
    state: {
        value: null,
        display: "State",
        type: "select",
        required: true,
    },
    zip: {
        value: "",
        display: "Zip Code",
        type: "tel",
        required: true,
    },
    addressType: {
        value: "Residential",
        display: "Address Type",
        type: "select",
        options: ["Residential", "Commercial"],
        required: true,
    },
    dueDate: {
        value: "",
        display: "Baby Due Date",
        type: "date",
        required: false,
    },
    phone: {
        value: "",
        display: "Phone Number",
        type: "tel",
        required: true,
    },
    hcProvider: {
        value: false,
        display: "Are you a healthcare provider?",
        details: "Yes",
        type: "checkbox",
        required: false,
    },
};

export { user };
